import { createThunkRoutine } from 'redux-thunk-routine';
import {
  FETCH_PRODUCTS_DATA,
  FETCH_LICENSES_DATA,
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
  CREATE_LICENSE,
  ASSIGN_LICENSE,
  REMOVE_LICENSE_FROM_CUSTOMER,
  EDIT_ASSIGNED_LICENSE,
  UPDATE_LICENSE,
  DELETE_LICENSE,
  GET_LICENSE_ROLES,
  GET_USERS_FOR_LICENSE,
  ASSIGN_USER_TO_LICENSE,
  UN_ASSIGN_USER_FROM_LICENSE,
} from './action-types';
import type {
  ILicenseRoles,
  ILicenseTemplate,
  ILicenseUsersResponse,
  IProduct,
} from './interfaces';

export const FetchProductsRoutine = createThunkRoutine<IProduct[]>(FETCH_PRODUCTS_DATA);
export const FetchLicensesRoutine = createThunkRoutine<ILicenseTemplate[]>(FETCH_LICENSES_DATA);
export const CreateProductRoutine = createThunkRoutine<IProduct>(CREATE_PRODUCT);
export const UpdateProductRoutine = createThunkRoutine<IProduct>(UPDATE_PRODUCT);
export const DeleteProductRoutine = createThunkRoutine<void>(DELETE_PRODUCT);

export const CreateLicenseRoutine = createThunkRoutine<ILicenseTemplate>(CREATE_LICENSE);
export const UpdateLicenseRoutine = createThunkRoutine<ILicenseTemplate>(UPDATE_LICENSE);
export const DeleteLicenseRoutine = createThunkRoutine<void>(DELETE_LICENSE);

export const AssignLicenseRoutine = createThunkRoutine<unknown>(ASSIGN_LICENSE);

export const RemoveLicenseFromCustomerRoutine = createThunkRoutine<number | undefined>(REMOVE_LICENSE_FROM_CUSTOMER);
export const AssignLicenseEditRoutine = createThunkRoutine<void>(EDIT_ASSIGNED_LICENSE);

export const GetLicenseRolesRoutine = createThunkRoutine<ILicenseRoles>(GET_LICENSE_ROLES);
export const GetUsersForLicenseRoutine = createThunkRoutine<ILicenseUsersResponse>(GET_USERS_FOR_LICENSE);
export const AssignLicenseToUserRoutine = createThunkRoutine<void>(ASSIGN_USER_TO_LICENSE);
export const UnAssignLicenseFromUserRoutine = createThunkRoutine<void>(UN_ASSIGN_USER_FROM_LICENSE);
